import * as app from "./scripts/app";
import "./styles/home.scss";
import * as Video from "./scripts/common/video";
import * as Login from "./scripts/common/login";
import * as Logout from "./scripts/common/logout";
import "./scripts/home/functions";
import * as Galeria from "./scripts/home/slideArticleHome";
import * as Ranking from "./scripts/home/masLeidas";
import * as LazyLoad from "./scripts/common/lazyload/lazyLoad";
import * as LoQueSigo from "./scripts/home/loQueSigo";
import * as UltimasNoticias from "./scripts/home/ultimasNoticias";
import * as BeneficioClubLn from "./scripts/home/beneficioClubLn";
import * as Tablero from './scripts/common/tableros';
import * as TableroTenis from './scripts/common/tableros/tableroTenis';
import * as TableroFutbol from './scripts/common/tableros/tableroFutbol';
import * as TableroRugby from './scripts/common/tableros/tableroRugby';
import * as TableroBasquet from './scripts/common/tableros/tableroBasket';
import * as Banners from './scripts/common/banners';
import * as Functions from "./scripts/common/functions";
import * as Personalizacion from './scripts/common/personalizacion';
import * as Utilities from "./scripts/common/utilities";
import * as CustomDimension from './scripts/common/analytics/CustomDimension';
import * as Pym from "./scripts/common/pymFunction.js";

window.LN = {};
window.LN.tipoPaginaBanner = "home";
var FirstQuarter = false;
var SecondQuarter = false;
var ThirdQuarter = false;
var FourthQuarter = false;

const guardarClima = () => {
    if (document.querySelector("#btnClimaHome")) {
        let btnClick = document.querySelector("#btnClimaHome");
        btnClick.addEventListener("click",
            function() {

                let ciudadClima = document.querySelector("#ciudadClima");
                let selectCiudad = document.querySelector("#ciudades");
                let currentOpt = selectCiudad.options[selectCiudad.selectedIndex];

                ciudadClima.textContent = currentOpt.text;

                $.ajax({
                    dataType: "jsonp",
                    cache: true,
                    url: window.config.Statics.ContenidosUrlRoot + "/json/pronostico/index-ciudadRef=" +
                        currentOpt.value,
                    jsonpCallback: "Pronostico",
                    success: function(json) {

                    }
                });
            });
    }
}

const initClima = () => {
    let ciudadClima = document.querySelector("#ciudadClima");

    if (ciudadClima != null) {
        let selectCiudad = document.querySelector("#ciudades");
        selectCiudad.selectedIndex = 8
        let currentOpt = selectCiudad.options[selectCiudad.selectedIndex];

        ciudadClima.textContent = currentOpt.text;

        $.ajax({
            dataType: "jsonp",
            cache: true,
            url: window.config.Statics.ContenidosUrlRoot + "/json/pronostico/index-ciudadRef=ARCF0009",
            jsonpCallback: "Pronostico",
            success: function(json) {

            }
        });
    }
}

window.pronosticoCallbackJSON = function(value) {
    let tempeClima = document.querySelector("#temperaturaClima");

    let ciudadClima = document.querySelector("#ciudadClima");
    let selectCiudad = document.querySelector("#ciudades");
    let currentOpt = selectCiudad.options[selectCiudad.selectedIndex];

    let ciudadData = value.ciudades.find(i => i.ciudad.codigo === currentOpt.value);

    tempeClima.textContent = ciudadData.ciudad.temperatura.concat("° ", ciudadData.ciudad.icono_descripcion);
    let imagenClima = document.querySelector("#imageClima");

    let idImagenClima = ciudadData.ciudad.icono_id.trim();
    let classClima = "clima-";

    imagenClima.classList.add(classClima.concat(idImagenClima));

}

const getTableros = () => {
    const tablero = document.body.querySelectorAll(".tablero");

    if (tablero.length > 0) {

        let tableros = [];
        
        let tFutbol = document.body.querySelectorAll("div.tablero.futbol");
        let tTenis = document.body.querySelectorAll("section.tablero.tenis");
        let tRugby = document.body.querySelectorAll("div.tablero.rugby");
        let tbasquet = document.body.querySelectorAll("div.tablero.basquet");

        if (tFutbol != null) {
            for (let i = 0; i < tFutbol.length; i++) {
                tableros.push(TableroFutbol.agregarTableroFutbol(tFutbol[i].getAttribute("data-id"), '1101'));
            }
        }
        if (tTenis != null) {
            for (let j = 0; j < tTenis.length; j++) {
                tableros.push(TableroTenis.agregarTableroTenis(tTenis[j].getAttribute("data-id"), '1000'));
            }
        }
        if (tRugby != null) {
            for (let j = 0; j < tRugby.length; j++) {
                tableros.push(TableroRugby.agregarTableroRugby(tRugby[j].getAttribute("data-id"), '1101'));
            }
        }
        if(tbasquet != null)
        {
            for (let j = 0; j < tbasquet.length; j++) {
                tableros.push(TableroBasquet.agregarTableroBasket(tbasquet[j].getAttribute("data-id"), '1101'));
            }
        }
                
        
        Tablero.iniciarTableros(tableros);
        Tablero.verificarCambiosCodigoControl();
        setInterval(Tablero.verificarCambiosCodigoControl, 15000);
    }
}

const LinksFooter = () => {
    if (document.querySelector("#pie-facebook")) {
        document.querySelector("#pie-facebook").addEventListener("click", function() { window.open("https://www.facebook.com/lanacion", "_blank") });
    }

    if (document.querySelector("#pie-twitter"))
        document.querySelector("#pie-twitter").addEventListener("click", function() { window.open("https://twitter.com/LANACION", "_blank") });

    if (document.querySelector("#pie-instagram"))
        document.querySelector("#pie-instagram").addEventListener("click", function() { window.open("https://www.instagram.com/lanacioncom/", "_blank") });

    if (document.querySelector("#pie-rss"))
        document.querySelector("#pie-rss").addEventListener("click", function() { window.open("http://servicios.lanacion.com.ar/herramientas/rss/ayuda", "_blank") });

    if (document.querySelector("#pie-apple"))
        document.querySelector("#pie-apple").addEventListener("click", function() { window.open("https://www.google.com.ar/url?sa=t&rct=j&q=&esrc=s&source=web&cd=1&cad=rja&uact=8&ved=0ahUKEwjsqvOLkr7XAhUDjpAKHZyiBigQFgglMAA&url=https%3A%2F%2Fitunes.apple.com%2Far%2Fapp%2Fla-nacion%2Fid410689702%3Fmt%3D8&usg=AOvVaw3LqfU_ag8u27BMNAtmRxqN", "_blank") });

    if (document.querySelector("#pie-android"))
        document.querySelector("#pie-android").addEventListener("click", function() { window.open("https://play.google.com/store/apps/details?id=app.lanacion.activity&hl=es_419", "_blank") });
}

const eventMetrics = () => {


    window.onscroll = () => {
        if (FirstQuarter === true &&
            SecondQuarter === true &&
            ThirdQuarter === true &&
            FourthQuarter === true) {
            return true;
        }
        const scrollTop = $(window).scrollTop();
        const docHeight = $(document).height();
        const winHeight = $(window).height();
        const scrollPercent = (scrollTop) / (docHeight - winHeight);
        const scrollPercentRounded = Math.round(scrollPercent * 100);
        if (scrollPercentRounded > 25 && FirstQuarter === false) {
            FirstQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '25' });
            }
        }
        if (scrollPercentRounded > 50 && SecondQuarter === false) {
            SecondQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '50' });
            }
        }
        if (scrollPercentRounded > 75 && ThirdQuarter === false) {
            ThirdQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '75' });
            }
        }
        if (scrollPercentRounded === 100 && FourthQuarter === false) {
            FourthQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '100' });
            }
        }

    }
}

const initialize = () => {
    Login.Initialize();
    Logout.Initialize();
    UltimasNoticias.getUltimasNoticias();
    Personalizacion.initPreferencias("home");
    Personalizacion.seguirDejarSeguir(document.querySelectorAll("button.seguir"));
    Banners.loadBanners(window.LN.tipoPaginaBanner);
    Video.initialize();
    Galeria.sliderArticle();
    Ranking.getHomeRanking();
    BeneficioClubLn.getPromoClubLnEnHome();
    LazyLoad.implementLazyLoadImage();
    initClima();
    getTableros();
    guardarClima();
    Functions.buscador();
    Functions.bannerHeaderLogo();
    LinksFooter();
    eventMetrics();
    Pym.initIframePym();
    Utilities.metaRefresh(300000, "home");
    CustomDimension.MakeCustomDimension();
}

//app.on(Events.APP_START, Functions.functions);
window.app = app;
app.start().then(initialize);


// WEBPACK FOOTER //
// ./Statics/home.js